import { useState } from "react";
import { timelineEvents } from "@/mocks/homeData";

const units = ["事件复盘", "时间线整理", "声明与回应"];

export default function Timeline() {
  const [unit, setUnit] = useState(0);

  return (
    <section id="timeline" className="shell-wrap py-14 md:py-20">
      <div className="grid gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-start">
        {/* intro */}
        <div className="lg:sticky lg:top-24">
          <p className="section-eyebrow">
            <i className="ri-history-line" /> 时间线整理
          </p>
          <h2 className="title-serif mt-2 text-2xl font-black leading-snug md:text-4xl">
            一条瓜的完整时间轴
            <span className="block text-ember">节点逐帧看清</span>
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-ink/65 md:text-base">
            把起因、发酵、反转与收尾按时间排布，标注每一次发声与沉默分别把风向推向何处，
            适合快速掌握「一场解约 / 一次声明」的完整脉络。
          </p>

          <div className="mt-6 flex flex-wrap gap-2">
            {units.map((u, i) => (
              <button
                key={u}
                type="button"
                onClick={() => setUnit(i)}
                className={
                  "rounded-full px-4 py-1.5 text-sm font-semibold transition-colors cursor-pointer " +
                  (unit === i
                    ? "bg-ember text-white"
                    : "border border-ink/15 bg-paper text-ink/65 hover:border-ember hover:text-ember")
                }
              >
                {u}
              </button>
            ))}
          </div>

          <div className="mt-6 rounded-xl border border-ember/20 bg-ember/5 p-4 text-xs leading-relaxed text-ink/70 md:text-sm">
            <b className="font-bold text-ember">归档提示：</b>
            本示例以「声明与回应」口径整理展示，站点内每条时间线均会标注信息来源类型，方便交叉比对。
          </div>
        </div>

        {/* timeline rail */}
        <ol className="relative ml-2 border-l-2 border-ink/15 pl-8 md:ml-4 md:pl-10">
          {timelineEvents.map((e, i) => (
            <li key={i} className="relative pb-8 last:pb-0">
              <span className="absolute -left-[41px] top-1 flex h-5 w-5 items-center justify-center rounded-full border-2 border-ember bg-paper md:-left-[51px]">
                <span className="h-2 w-2 rounded-full bg-ember" />
              </span>
              <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                <span className="title-serif text-sm font-black text-ember">{e.date}</span>
                <span className="text-xs text-ink/45">{e.time}</span>
              </div>
              <h3 className="title-serif mt-1.5 text-base font-black md:text-lg">{e.title}</h3>
              <p className="mt-1 max-w-lg text-sm leading-relaxed text-ink/60">{e.note}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}